<div class="dashboard-container">
  <!-- ========================================== -->
  <!-- SECTION 1: SKELETON LOADERS -->
  <!-- ========================================== -->
  <ng-container *ngIf="isInitialLoad">
    <!-- Filters Skeleton -->
    <div class="bg-white p-4 rounded-xl border border-gray-100 shadow-sm mb-6">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        <div *ngFor="let i of [1,2,3,4,5]">
          <div class="h-3 w-16 bg-gray-100 rounded skeleton-shimmer mb-2"></div>
          <div class="h-9 w-full bg-gray-50 rounded skeleton-shimmer"></div>
        </div>
      </div>
    </div>

    <!-- Stats Skeleton -->
    <div class="stats-grid mt-1">
      <div *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11]"
        class="h-full border border-gray-100 rounded-lg p-3 flex flex-col bg-white">
        <div class="mb-2 flex items-center justify-between">
          <div class="h-4 w-32 bg-gray-100 rounded skeleton-shimmer"></div>
          <div class="h-5 w-5 bg-gray-100 rounded skeleton-shimmer"></div>
        </div>
        <div class="h-8 w-20 bg-gray-50 rounded skeleton-shimmer mt-auto"></div>
      </div>
    </div>

    <!-- Users Skeleton -->
    <div class="section-container mt-6">
      <div class="section-header">
        <div class="h-7 w-32 bg-gray-200 rounded skeleton-shimmer"></div>
      </div>
      <!-- Desktop Table Skeleton -->
      <div class="space-y-4 hidden md:block">
        <app-skeleton-loader type="table" [count]="4" [tableColumns]="['w-40', 'w-60', 'w-32']"></app-skeleton-loader>
      </div>
      <!-- Mobile Card Skeleton -->
      <div class="space-y-4 block md:hidden">
        <div *ngFor="let i of [1,2,3,4]" class="bg-white rounded border border-gray-200 p-4">
          <div class="space-y-3">
            <div class="border-b border-gray-200 pb-2">
              <div class="h-5 w-32 bg-gray-200 rounded skeleton-shimmer"></div>
            </div>
            <div class="space-y-2">
              <div class="flex justify-between items-center">
                <div class="h-4 w-16 bg-gray-100 rounded skeleton-shimmer"></div>
                <div class="h-4 w-40 bg-gray-200 rounded skeleton-shimmer"></div>
              </div>
              <div class="flex justify-between items-center">
                <div class="h-4 w-12 bg-gray-100 rounded skeleton-shimmer"></div>
                <div class="h-6 w-20 bg-gray-200 rounded-full skeleton-shimmer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- View All Link Skeleton -->
      <div class="mt-4">
        <div class="h-5 w-24 bg-gray-100 rounded skeleton-shimmer"></div>
      </div>
    </div>

    <!-- Telecallers Skeleton -->
    <div class="section-container mt-6">
      <div class="section-header">
        <div class="h-7 w-40 bg-gray-200 rounded skeleton-shimmer"></div>
      </div>
      <!-- Desktop Table Skeleton -->
      <div class="space-y-4 hidden md:block">
        <app-skeleton-loader type="table" [count]="4"
          [tableColumns]="['w-32', 'w-48', 'w-24', 'w-24', 'w-24']"></app-skeleton-loader>
      </div>
      <!-- Mobile Card Skeleton -->
      <div class="space-y-4 block md:hidden">
        <div *ngFor="let i of [1,2,3,4]" class="bg-white rounded border border-gray-200 p-4">
          <div class="space-y-3">
            <div class="border-b border-gray-200 pb-2">
              <div class="h-5 w-40 bg-gray-200 rounded skeleton-shimmer"></div>
            </div>
            <div class="space-y-2">
              <div class="flex justify-between items-center">
                <div class="h-4 w-8 bg-gray-100 rounded skeleton-shimmer"></div>
                <div class="h-4 w-24 bg-gray-200 rounded skeleton-shimmer"></div>
              </div>
              <div class="flex justify-between items-start">
                <div class="h-4 w-20 bg-gray-100 rounded skeleton-shimmer"></div>
                <div class="flex gap-1">
                  <div class="h-6 w-16 bg-gray-200 rounded-full skeleton-shimmer"></div>
                </div>
              </div>
              <div class="flex justify-between items-center">
                <div class="h-4 w-16 bg-gray-100 rounded skeleton-shimmer"></div>
                <div class="h-4 w-12 bg-gray-200 rounded skeleton-shimmer"></div>
              </div>
              <div class="flex justify-between items-center">
                <div class="h-4 w-24 bg-gray-100 rounded skeleton-shimmer"></div>
                <div class="h-4 w-20 bg-gray-200 rounded skeleton-shimmer"></div>
              </div>
            </div>
            <div class="pt-2">
              <div class="h-10 w-full bg-gray-100 rounded skeleton-shimmer"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- View All Link Skeleton -->
      <div class="mt-4">
        <div class="h-5 w-24 bg-gray-100 rounded skeleton-shimmer"></div>
      </div>
    </div>
  </ng-container>

  <!-- ========================================== -->
  <!-- SECTION 2: PAGE CONTENT -->
  <!-- ========================================== -->
  <ng-container *ngIf="!isInitialLoad">
    <!-- Filters Section -->
    <app-filters [(filters)]="filters" [visibleFilters]="['zone', 'hq', 'state', 'city', 'mr', 'period']"
      (filterChange)="onFilterChange()"></app-filters>

    <!-- Stats Cards -->
    <div class="stats-grid mt-1 fade-in">
      <app-stats-card title="Total Patients" [value]="stats.totalPatients" icon="users" color="blue"
        [isLoading]="isLoadingStats"></app-stats-card>

      <app-stats-card title="Enrolled Patients" [value]="stats.enrolledPatients" icon="userstats" color="emerald"
        [isLoading]="isLoadingStats"></app-stats-card>

      <app-stats-card title="Enrollment Rate" [value]="stats.enrollmentRate + '%'" icon="active" color="teal"
        [isLoading]="isLoadingStats"></app-stats-card>

      <app-stats-card *ngIf="!isSalesMr" title="Current Month Revenue" [value]="stats.currentMonthRevenue"
        icon="revenue" color="amber" [isLoading]="isLoadingStats"></app-stats-card>

      <app-stats-card title="Medicine Orders" [value]="stats.medicineOrders" icon="cart" color="orange"
        [isLoading]="isLoadingStats"></app-stats-card>

      <app-stats-card title="Test Bookings" [value]="stats.testBookings" icon="flask" color="purple"
        [isLoading]="isLoadingStats"></app-stats-card>

      <app-stats-card *ngIf="!isSalesMr" title="Active MRs" [value]="stats.activeMrs + ' / ' + stats.totalMrs"
        icon="telecaller" color="indigo" [isLoading]="isLoadingStats"></app-stats-card>

      <app-stats-card title="Total Doctors" [value]="stats.totalDoctors" icon="doctor" color="cyan"
        [isLoading]="isLoadingStats"></app-stats-card>

      <app-stats-card title="Total Hospitals" [value]="stats.totalHospitals" icon="hospital" color="rose"
        [isLoading]="isLoadingStats"></app-stats-card>

      <app-stats-card title="Total Medications" [value]="stats.totalMedications" icon="inventory" color="violet"
        [isLoading]="isLoadingStats"></app-stats-card>

      <app-stats-card title="Avg. Compliance" [value]="stats.avgComplianceRate + '%'" icon="phoneCheck" color="green"
        [isLoading]="isLoadingStats"></app-stats-card>
    </div>

    <!-- Breakdown Tables -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-6 fade-in">
      <!-- Medicine Wise Patients -->
      <div class="table-container" *ngIf="medicineWisePatients.length">
        <h3 class="text-sm  text-content1 px-4 pt-4 pb-2">Medicine Wise Patients</h3>
        <table class="w-full text-left border-collapse text-sm">
          <thead class="border-b border-gray-200">
            <tr>
              <th class="px-4 py-2  text-content2">Medicine</th>
              <th class="px-4 py-2  text-content2">Patients</th>
              <th class="px-4 py-2  text-content2">Revenue</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of medicineWisePatients" class="border-b border-gray-100">
              <td class="px-4 py-2">{{ item.medicine }}</td>
              <td class="px-4 py-2">{{ item.total_patients }}</td>
              <td class="px-4 py-2">{{ item.total_revenue | currency:'INR':'symbol':'1.0-0' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- HQ Wise Patients -->
      <div class="table-container" *ngIf="hqWisePatients.length">
        <h3 class="text-sm  text-content1 px-4 pt-4 pb-2">HQ Wise Patients</h3>
        <table class="w-full text-left border-collapse text-sm">
          <thead class="border-b border-gray-200">
            <tr>
              <th class="px-4 py-2  text-content2">HQ</th>
              <th class="px-4 py-2  text-content2">Patients</th>
              <th class="px-4 py-2  text-content2">Revenue</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of hqWisePatients" class="border-b border-gray-100">
              <td class="px-4 py-2">{{ item.hq_name }}</td>
              <td class="px-4 py-2">{{ item.total_patients }}</td>
              <td class="px-4 py-2">{{ item.total_revenue | currency:'INR':'symbol':'1.0-0' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Manager HQ Wise Patients -->
      <div class="table-container" *ngIf="managerHqWisePatients.length">
        <h3 class="text-sm  text-content1 px-4 pt-4 pb-2">Manager HQ Wise Patients</h3>
        <table class="w-full text-left border-collapse text-sm">
          <thead class="border-b border-gray-200">
            <tr>
              <th class="px-4 py-2  text-content2">MR</th>
              <th class="px-4 py-2  text-content2">Patients</th>
              <th class="px-4 py-2  text-content2">Revenue</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of managerHqWisePatients" class="border-b border-gray-100">
              <td class="px-4 py-2">{{ item.mr_name }}</td>
              <td class="px-4 py-2">{{ item.total_patients }}</td>
              <td class="px-4 py-2">{{ item.total_revenue | currency:'INR':'symbol':'1.0-0' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Doctor Wise Patients -->
      <div class="table-container" *ngIf="drWisePatients.length">
        <h3 class="text-sm  text-content1 px-4 pt-4 pb-2">Doctor Wise Patients</h3>
        <table class="w-full text-left border-collapse text-sm">
          <thead class="border-b border-gray-200">
            <tr>
              <th class="px-4 py-2  text-content2">Doctor</th>
              <th class="px-4 py-2  text-content2">Patients</th>
              <th class="px-4 py-2  text-content2">Revenue</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of drWisePatients" class="border-b border-gray-100">
              <td class="px-4 py-2">{{ item.doctor_name }}</td>
              <td class="px-4 py-2">{{ item.total_patients }}</td>
              <td class="px-4 py-2">{{ item.total_revenue | currency:'INR':'symbol':'1.0-0' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Users Section -->
    <div class="section-container mt-3">
      <div class="section-header">
        <h2 class="section-title">Users</h2>
      </div>

      <!-- Empty State -->
      <app-empty-state *ngIf="!isLoadingUsers && users.length === 0" icon="users" [iconSize]="40" [compact]="true"
        title="No users found" description="There are no users in this organization yet."
        class="bg-gray-50 rounded border border-dashed border-gray-300"></app-empty-state>

      <!-- Data Content -->
      <ng-container *ngIf="!isLoadingUsers && users.length > 0">
        <!-- Desktop/Web View - Table Layout -->
        <div class="border rounded bg-white hidden md:block">
          <table class="w-full text-left border-collapse text-sm">
            <thead class="border-b border-gray-200">
              <tr>
                <th class="table-header">Name</th>
                <th class="table-header">Email</th>
                <th class="table-header">Role</th>
              </tr>
            </thead>
            <tbody>
              @for (user of users; track user.id) {
              <tr class="border-b hover:bg-gray-50 transition group">
                <td class="table-item  text-gray-900">{{ user.name }}</td>
                <td class="table-item text-gray-600">{{ user.email }}</td>
                <td class="table-item">
                  <app-badge [text]="user.role" [variant]="getRoleVariant(user.role)" size="sm"></app-badge>
                </td>
                <!-- <td class="table-item text-right">
                  <div class="dropdown opacity-0 group-hover:opacity-100 transition-opacity">
                    <label class="cursor-pointer" tabindex="0">
                      <app-icon name="threedot"></app-icon>
                    </label>
                    <div class="dropdown-menu dropdown-menu-left-bottom">
                      <a class="dropdown-item text-sm flex flex-row gap-2">
                        <app-icon name="edit"></app-icon>
                        <span>Edit Details</span>
                      </a>
                      <a tabindex="-1" class="dropdown-item text-sm flex flex-row gap-2">
                        <app-icon name="link"></app-icon>
                        <span>Send Reset Password Link</span>
                      </a>
                      <a
                        tabindex="-1"
                        class="dropdown-item text-sm text-red-500 flex flex-row gap-2"
                      >
                        <app-icon name="trash"></app-icon>
                        <span>Remove User</span>
                      </a>
                    </div>
                  </div>
                </td> -->
              </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Mobile View - Card Layout -->
        <div class="block md:hidden space-y-4">
          @for (user of users; track user.id) {
          <div class="bg-white rounded border border-gray-200 p-4">
            <div class="space-y-3">
              <div class="border-b border-gray-200 pb-2">
                <h3 class="text-lg max-md:text-base  text-gray-900">
                  {{ user.name }}
                </h3>
              </div>
              <div class="space-y-2">
                <div class="flex justify-between items-center">
                  <span class="text-sm  text-gray-600">Email:</span>
                  <span class="text-sm text-gray-900">{{ user.email }}</span>
                </div>
                <div class="flex justify-between items-center">
                  <span class="text-sm  text-gray-600">Role:</span>
                  <app-badge [text]="user.role" [variant]="getRoleVariant(user.role)" size="sm"></app-badge>
                </div>
              </div>
            </div>
          </div>
          }
        </div>

        <!-- View All Link -->
        <div class="view-all-container">
          <a class="view-all-link" routerLink="/organization">
            View All
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </a>
        </div>
      </ng-container>
    </div>

    <!-- Telecallers Section -->
    <div class="section-container" *ngIf="!isSalesMr">
      <div class="section-header">
        <h2 class="section-title">Telecallers</h2>
      </div>

      <!-- Empty State -->
      <app-empty-state *ngIf="!isLoadingTelecallers && telecallers.length === 0" icon="telecaller" [iconSize]="40"
        [compact]="true" title="No telecallers found" description="There are no telecallers assigned yet."
        class="bg-gray-50 rounded border border-dashed border-gray-300"></app-empty-state>

      <!-- Data Content -->
      <ng-container *ngIf="!isLoadingTelecallers && telecallers.length > 0">
        <!-- Desktop/Web View - Table Layout -->
        <div class="rounded bg-white hidden md:block">
          <table class="w-full text-left border-collapse text-sm">
            <thead class="border-b border-gray-200">
              <tr>
                <th class="table-header">ID</th>
                <th class="table-header">Name</th>
                <th class="table-header">Programs Assigned</th>
                <th class="table-header">Patients Assigned</th>
                <th class="table-header">Total Sales</th>
              </tr>
            </thead>
            <tbody>
              @for (telecaller of telecallers; track telecaller.id) {
              <tr class="border-b hover:bg-gray-50 transition ripple group">
                <td class="table-item table-link" [routerLink]="['/telecaller/telecaller-detail', telecaller.id]">{{
                  telecaller.user_id }}</td>
                <td class="table-item table-link" [routerLink]="['/telecaller/telecaller-detail', telecaller.id]">{{
                  telecaller.name }}</td>
                <td class="table-item">
                  <div class="flex flex-wrap gap-1">
                    {{ telecaller.programCount }}
                  </div>
                </td>
                <td class="table-item text-gray-600">{{ telecaller.patientsAssigned }}</td>
                <td class="table-item text-gray-900 ">{{ telecaller.totalSales }}</td>
                <!-- <td class="table-item text-right">
                  <div class="dropdown opacity-0 group-hover:opacity-100 transition-opacity">
                    <label class="cursor-pointer" tabindex="0">
                      <app-icon name="threedot"></app-icon>
                    </label>
                    <div class="dropdown-menu dropdown-menu-left-bottom">
                      <a class="dropdown-item text-sm flex flex-row gap-2">
                        <app-icon name="edit"></app-icon>
                        <span>Edit Details</span>
                      </a>
                      <a
                        tabindex="-1"
                        class="dropdown-item text-sm text-red-500 flex flex-row gap-2"
                      >
                        <app-icon name="trash"></app-icon>
                        <span>Remove</span>
                      </a>
                    </div>
                  </div>
                </td> -->
              </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Mobile View - Card Layout -->
        <div class="block md:hidden space-y-4">
          @for (telecaller of telecallers; track telecaller.id) {
          <div class="bg-white rounded border border-gray-200 p-4">
            <div class="space-y-3">
              <div class="border-b border-gray-200 pb-2">
                <h3 class="text-lg max-md:text-base  text-gray-900">
                  {{ telecaller.name }}
                </h3>
              </div>
              <div class="space-y-2">
                <div class="flex justify-between items-center">
                  <span class="text-sm  text-gray-600">ID:</span>
                  <span class="text-sm text-gray-900">{{ telecaller.id }}</span>
                </div>
                <div class="flex justify-between items-start">
                  <span class="text-sm  text-gray-600">Programs:</span>
                  <div class="programs-cell">
                    @for (program of telecaller.displayPrograms; track program) {
                    <span class="program-tag">{{ program }}</span>
                    } @if (telecaller.morePrograms > 0) {
                    <span class="program-more">+{{ telecaller.morePrograms }}</span>
                    }
                  </div>
                </div>
                <div class="flex justify-between items-center">
                  <span class="text-sm  text-gray-600">Patients:</span>
                  <span class="text-sm text-gray-900">{{ telecaller.patientsAssigned }}</span>
                </div>
                <div class="flex justify-between items-center">
                  <span class="text-sm  text-gray-600">Total Sales:</span>
                  <span class="text-sm text-gray-900">₹{{ telecaller.totalSales }}</span>
                </div>
              </div>
              <div class="pt-2">
                <button class="btn btn-secondary w-full">View Details</button>
              </div>
            </div>
          </div>
          }
        </div>

        <!-- View All Link -->
        <div class="view-all-container">
          <a class="view-all-link" routerLink="/telecaller">
            View All
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </a>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- ========================================== -->
  <!-- SECTION 3: ALL MODALS -->
  <!-- ========================================== -->
  <!-- No modals in this component -->
</div>